/* eslint-disable import/first */

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import DashboardPlugin from './plugins/now-ui/dashboard-plugin'
import VueRecaptcha from 'vue-recaptcha'

import * as VueGoogleMaps from 'vue2-google-maps'
import './element-ui'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Tabs from './components/now-ui/Tabs/Tabs'
import Tab from './components/now-ui/Tabs/Tab'
import { VERSION } from './http'
import PortalVue from 'portal-vue'

library.add(fas)
library.add(far)
library.add(fab)

Vue.config.productionTip = false

Vue.component(Tabs.name, Tabs)
Vue.component(Tab.name, Tab)

Vue.use(DashboardPlugin)
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyBL8qPFiS8iwBaujGSYOeNWubHtbg2LnRk', libraries: 'places' } })
Vue.use(VueQuillEditor)
Vue.component('recaptcha', VueRecaptcha)
Vue.component('fa', FontAwesomeIcon)
Vue.use(PortalVue)

Vue.prototype.$version = VERSION;

export default new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

import './assets/css/element_variables.scss'
